import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Reports/hooks/useReportEntryTypesByIds.ts
/**
* Get a list of EntryTypes.
*
* Note: data does not include the FormBuilder schema
*
* @param args
* @param opts
*/
function useReportEntryTypesByIds(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportEntryTypesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.entryTypeIds?.length
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReportEntryTypesByIds };

//# sourceMappingURL=useReportEntryTypesByIds.js.map